const en = {

  // ── Common / Global ──────────────────────────────────────────
  common: {
    appName: 'ERPhub',
    appTagline: 'Multi-Branch Sales, Inventory & POS',
    loading: 'Loading...',
    saving: 'Saving…',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    create: 'Create',
    update: 'Update',
    search: 'Search…',
    filter: 'Filter',
    export: 'Export CSV',
    print: 'Print',
    refresh: 'Refresh',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    prev: 'Prev',
    yes: 'Yes',
    no: 'No',
    confirm: 'Confirm',
    submit: 'Submit',
    reset: 'Reset',
    clear: 'Clear',
    view: 'View',
    detail: 'Detail',
    actions: 'Actions',
    status: 'Status',
    date: 'Date',
    time: 'Time',
    name: 'Name',
    code: 'Code',
    type: 'Type',
    notes: 'Notes',
    total: 'Total',
    subtotal: 'Subtotal',
    discount: 'Discount',
    tax: 'Tax',
    amount: 'Amount',
    price: 'Price',
    qty: 'Qty',
    quantity: 'Quantity',
    unit: 'Unit',
    branch: 'Branch',
    customer: 'Customer',
    product: 'Product',
    noRecords: 'No records',
    noData: 'No data found',
    accessDenied: 'Access Denied',
    contactAdmin: 'Contact your administrator.',
    welcome: 'Welcome,',
    signOut: 'Sign Out',
    language: 'Language',
    required: '(required)',
    all: 'All',
    page: 'Page',
    of: 'of',
    showing: 'Showing',
    results: 'results',
    description: 'Description',
    created: 'Created',
    updated: 'Updated',
    deleted: 'Deleted',
    failed: 'Failed',
    active: 'Active',
    inactive: 'Inactive',
    viewOnly: 'View Only',
    deleteConfirm: 'Delete permanently?',
    nameRequired: 'Name required',
    image: 'Image',
    uploadFailed: 'Upload failed',
    uploaded: 'Uploaded',
    remove: 'Remove',
    apply: 'Apply',
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    last30: 'Last 30 days',
    allTime: 'All Time',
    custom: 'Custom',
    from: 'From',
    to: 'To',
    fromDate: 'From Date',
    toDate: 'To Date',
    id: 'ID',
    reference: 'Reference',
    method: 'Method',
    value: 'Value',
    count: 'Count',
    percent: 'Percent',
    sortOrder: 'Sort Order',
    priority: 'Priority',
    channel: 'Channel',
    device: 'Device',
    user: 'User',
    role: 'Role',
    currency: 'Currency',
    rate: 'Rate',
    symbol: 'Symbol',
    margin: 'Margin',
    scheduled: 'Scheduled',
    automatic: 'Automatic',
    sent: 'Sent',
    unread: 'Unread',
    analytics: 'Analytics',
    summary: 'Summary',
    balance: 'Balance',
    rank: 'Rank',
    revenue: 'Revenue',
    revenue2: 'Revenue',
    transactions: 'Transactions',
    overview: 'Overview',
    recent: 'Recent',
    recentActivity: 'Recent Activity',
    share: 'Share',
    fullscreen: 'Fullscreen',
    exitFullscreen: 'Exit Fullscreen',
    loadReportFirst: 'Load a report first',
    linkCopied: 'Link copied!',
    markRead: 'Mark as read',
    notConfigured: 'Not configured',
    optional: '(optional)',
    imageFilesOnly: 'Image files only',
    max5mb: 'Max 5MB',
    taxRate: 'Tax Rate (%)',
    taxPercent: 'Tax %',
    addr: 'Address',
    phone: 'Phone',
    email: 'Email',
    website: 'Website',
    city: 'City',
    country: 'Country',
    on: 'On',
    off: 'Off',
    set: 'Set',
    notSet: 'Not set',
    enabled: 'Enabled',
    disabled: 'Disabled',
    save2: 'Save',
    saved: 'Saved',
    exported: 'Exported',
    reportExported: 'Report exported',
    reportExportedSuccess: 'Report exported successfully',
    failedToLoad: 'Failed to load',
    failedToSave: 'Failed to save',
    failedToUpdate: 'Failed to update',
    activate: 'Activate',
    deactivate: 'Deactivate',
    activated: 'Activated',
    deactivated: 'Deactivated',
    yourBranch: 'Your Branch',
    searchBranchCashier: 'Search branch, cashier...',
    searchByNameCodeCity: 'Search by name, code, city...',
    enterName: 'Enter name',
    pleaseEnterName: 'Please enter a name',
  },

  // ── Auth / Login ─────────────────────────────────────────────
  auth: {
    email: 'Email',
    password: 'Password',
    signIn: 'Sign In',
    signingIn: 'Signing in...',
    demoAccounts: 'DEMO ACCOUNTS',
    welcomeBack: 'Welcome!',
    loginFailed: 'Login failed',
  },

  // ── Navigation / Sidebar ─────────────────────────────────────
  nav: {
    main: 'Main',
    sales: 'Sales',
    inventory: 'Inventory',
    finance: 'Finance',
    system: 'System',
    dashboard: 'Dashboard',
    pos: 'POS',
    posSessions: 'POS Sessions',
    orders: 'Orders',
    invoices: 'Invoices',
    customers: 'Customers',
    products: 'Products',
    masterData: 'Master Data',
    stock: 'Stock',
    purchaseOrders: 'Purchase Orders',
    stockTransfers: 'Stock Transfers',
    vendors: 'Vendors',
    commissions: 'Commissions',
    payments: 'Payments',
    expenses: 'Expenses',
    promotions: 'Promotions',
    currencies: 'Currencies',
    branches: 'Branches',
    users: 'Users',
    reports: 'Reports',
    settings: 'Settings',
  },

  // ── Dashboard ────────────────────────────────────────────────
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Business overview',
    revenue: 'REVENUE',
    outstanding: 'OUTSTANDING',
    customers: 'CUSTOMERS',
    products: 'PRODUCTS',
    posToday: 'POS TODAY',
    paidInvoices: 'Paid invoices',
    unpaid: 'Unpaid',
    lowStock: 'low stock',
    txns: 'txns',
    recentOrders: 'Recent Orders',
    pendingCommissions: 'Pending Commissions',
    invoiceStatus: 'Invoice Status',
    none: 'None',
  },

  // ── Orders ───────────────────────────────────────────────────
  orders: {
    invoiceCreatedStockDeducted: 'Invoice {{num}} created — stock deducted',
    insufficientStockOrder: 'Insufficient stock to convert order to invoice',
    orderStockDeductNote: 'Stock will be deducted automatically when converting to invoice',
    title: 'Sale Orders',
    newOrder: 'New Order',
    orderNumber: 'Order #',
    orderDate: 'Order Date',
    orderLines: 'ORDER LINES',
    selectCustomer: '— Select Customer —',
    selectBranch: '— Select Branch —',
    noOrders: 'No orders found',
    createOrder: 'Create Order',
    saveChanges: 'Save Changes',
    deleteOrder: 'Delete Order',
    confirmDelete: 'Delete this order?',
    readyToInvoice: 'Ready to invoice?',
    createInvoiceDesc: 'Create a sales invoice from this order. The order will be marked Completed automatically.',
    createInvoice: 'Create Invoice',
    creating: 'Creating…',
    invoiceCreated: 'Invoice {{num}} created',
    orderCompleted: 'Order marked as Completed · Go to Sale Invoices to view',
    statusChanged: 'Status → {{status}}',
    noItems: 'No lines — click Add',
    noItemsMobile: 'No lines — tap Add',
    addItem: 'Add',
    selectProduct: '— Select product —',
    searchProduct: 'Search name or SKU...',
    noProductsFound: 'No products found',
    itemsCount: '{{n}} item',
    itemsCountPlural: '{{n}} items',
    changeStatus: 'Change Status',
    invoiced: 'INVOICED',
    orderCreated: 'Order created',
    orderUpdated: 'Order updated',
    orderNeedsBranch: 'Order requires a branch before invoicing',
    orderNotFound: 'Order not found',
    failedCreateInvoice: 'Failed to create invoice',
    failedLoadOrder: 'Failed to load order',
    failedLoadOrders: 'Failed to load orders',
    orderNotes: 'Order Notes (optional)',
    deliveryAddress: 'Delivery Address',
    orderAnalyticsReport: 'Order Analytics Report',
    orderCustomerDetail: 'Order & Customer Detail',
    allOrders: 'All Orders',
    totalOrders: 'Total Orders',
    totalRevenue: 'Total Revenue',
    searchOrders: 'Search # order, customer, product…',
    failedPlaceOrder: 'Failed to place order',
    status: {
      draft: 'Draft',
      pending: 'Pending',
      confirmed: 'Confirmed',
      processing: 'Processing',
      shipped: 'Shipped',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    columns: {
      num: '#',
      product: 'Product',
      uom: 'UOM',
      qty: 'Qty',
      unitPrice: 'Unit Price',
      amount: 'Amount',
    },
  },

  // ── Invoices ─────────────────────────────────────────────────
  invoices: {
    title: 'Sale Invoices',
    newInvoice: 'New Invoice',
    invoiceNumber: 'Invoice #',
    invoiceDate: 'Invoice Date',
    dueDate: 'Due Date',
    dueLabel: 'Due',
    paymentTerms: 'Payment Terms',
    paymentTermsPlaceholder: 'e.g. Net 30',
    lineItems: 'LINE ITEMS',
    balance: 'Balance',
    paid: 'Paid',
    recordPayment: 'Record Payment',
    balanceDue: 'Balance Due',
    settled: '✓ Settled',
    totalInvoiced: 'Total Invoiced',
    collected: 'Collected',
    outstanding: 'Outstanding',
    invoiced: 'Invoiced',
    changeStatus: 'Change Status',
    noInvoices: 'No invoices found',
    customerRequired: 'Please select a customer',
    addAtLeastOne: 'Please add at least one product',
    noProductsFound: 'No products found',
    noStockAtBranch: 'No stock at this branch',
    stockDeductFailed: 'Stock deduction failed',
    paymentRecorded: 'Payment recorded',
    invoiceUpdated: 'Invoice updated',
    invoiceCreated: 'Invoice created',
    failedToLoad: 'Failed to load',
    failedToSave: 'Failed to save',
    enterValidAmount: 'Please enter a valid amount',
    customerName: 'Customer Name',
    totalAmountDue: 'Total Amount Due',
    createdBy: 'Created By',
    paymentReceived: 'Payment received',
    paymentHistory: 'Payment History',
    notesPaymentTerms: 'Notes / Payment Terms',
    internalNotes: 'Internal notes…',
    companyName: 'Company Name',
    stockFromBranch: 'Stock from Branch',
    searchInvoice: 'Invoice # or customer...',
    yourBranch: 'Your Branch',
    order: 'Order',
    totalInvoices: 'Total Invoices',
    disc: 'Disc',
    out: 'Outstanding',
    columns: {
      num: '#',
      product: 'Product',
      uom: 'UoM',
      qty: 'Qty',
      unitPrice: 'Unit Price',
      discount: 'Disc',
      amount: 'Amount',
      price: 'Price',
    },
    status: {
      draft: 'Draft',
      sent: 'Sent',
      paid: 'Paid',
      partial: 'Partial',
      overdue: 'Overdue',
      cancelled: 'Cancelled',
    },
    pay: {
      title: 'Record Payment — {{num}}',
      amount: 'Amount *',
      method: 'Method',
      reference: 'Reference / Transaction ID',
      refPlaceholder: 'e.g. TXN-12345',
    },
  },

  // ── POS ──────────────────────────────────────────────────────
  pos: {
    openSession: 'Open POS Session',
    openRegister: 'Open Register',
    openingBalance: 'Opening Balance (USD)',
    closeSession: 'Close POS Session',
    closeRegister: 'Close Register',
    closingBalance: 'Closing Balance (USD)',
    closePrompt: 'Count your cash drawer and enter the closing balance.',
    forceClose: 'Force Close',
    registerOpen: 'Register Open',
    cashRegisterClosed: 'Cash Register Closed',
    noPermissionOpen: 'No permission to open session',
    noPermissionClose: 'No permission to close this session',
    sessionClosedSuccess: 'Session closed successfully',
    sessionsExported: 'Sessions exported',
    products: 'Products',
    cart: 'Cart',
    orders: 'Orders',
    cartItems: '({{n}} items)',
    clearCart: 'Clear',
    outOfStock: 'Out of stock!',
    onlyInStock: 'Only {{n}} in stock',
    addedToCart: 'Added {{name}}',
    charge: 'Charge {{amount}}',
    payment: '💳 Payment',
    totalDue: 'Total Due',
    paymentMethods: 'PAYMENT METHODS',
    change: 'Change',
    shortBy: '⚠️ Short by {{amount}}',
    insufficientPayment: 'Insufficient payment',
    completeSale: 'Complete Sale',
    saleCompleted: '✅ Sale completed!',
    saleFailed: 'Sale failed',
    walkIn: 'Walk-in Customer',
    discount: 'Discount:',
    fixed: '$ Fixed',
    percent: '% Percent',
    searchProducts: 'Search name, SKU, barcode...',
    noProductsFound: 'No products found',
    void: 'Void',
    voiding: 'Voiding…',
    voidTransaction: 'Void This Transaction',
    voidConfirm: 'Confirm Void?',
    voidDesc: 'This will mark the transaction as voided and restore all inventory. This cannot be undone.',
    voided: 'Transaction Voided',
    voidedDesc: 'Inventory has been restored for all items.',
    voidSuccess: '{{num}} voided — stock restored',
    voidFailed: 'Void failed',
    transactionNumber: 'Transaction #',
    paymentBreakdown: 'Payment Breakdown',
    lineItems: 'ORDER LINES',
    noSession: 'No open session',
    receipt: 'Receipt',
    reprintReceipt: 'Reprint Receipt',
    cashSales: 'Cash Sales',
    cardSales: 'Card Sales',
    openingBal: 'Opening Balance',
    closingBal: 'Closing Balance',
    expected: 'Expected',
    actualClosing: 'Actual Closing',
    difference: 'Difference',
    short: 'Short',
    over: 'Over',
    openingTime: 'Opening Time',
    closingTime: 'Closing Time',
    cashBalance: 'Cash Balance',
    resetToExpected: 'Reset to Expected',
  },

  // ── POS Sessions ─────────────────────────────────────────────
  posSessions: {
    title: 'POS Sessions & Reports',
    posReports: 'POS Reports',
    sessionList: 'Session List',
    branchReports: 'Branch Reports',
    ordersReport: 'Orders Report',
    customersReport: 'Customers Report',
    byOrder: 'By Order',
    byCustomer: 'By Customer',
    byHour: 'By Hour',
    detail: 'Detail',
    open: 'Open',
    closed: 'Closed',
    closing: 'Closing',
    stillOpen: 'Still Open',
    duration: 'Duration',
    totalSales: 'Total Sales',
    transactions: 'Transactions',
    openSessions: 'Open Sessions',
    closedSessions: 'Closed Sessions',
    allSessions: 'All Sessions',
    totalSessions: 'Total Sessions',
    avgPerSession: 'Avg / Session',
    avgSession: 'Avg Sales / Session',
    noSessions: 'No sessions found',
    failedLoadSessions: 'Failed to load sessions',
    runReport: 'Run Report',
    dateFrom: 'FROM',
    dateTo: 'TO',
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    last30: 'Last 30d',
    allTime: 'All Time',
    branchPerformance: 'Branch Performance Ranking',
    viewDetails: 'View details',
    revenue: 'REVENUE',
    avgTxn: 'AVG TXN',
    avgTransaction: 'Avg Transaction',
    pctOfTotal: '% of total',
    topCashiers: 'Top Cashiers',
    cashiers: 'Cashiers',
    topProducts: 'Top Products',
    paymentMethods: 'Payment Methods',
    dailySales: 'Daily Sales Trend',
    dailyTrend: 'Daily Trend',
    dailyComparison: 'Daily Sales Comparison — All Branches',
    branchSummary: 'Branch Summary Table',
    groupBy: 'GROUP BY',
    hour: 'Hour',
    hourly: 'Hourly',
    avgHourly: 'Avg Hourly',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    sortBy: 'SORT BY',
    byRevenue: 'Total Revenue',
    byFrequency: 'Visit Frequency',
    byAvgOrder: 'Avg Order Value',
    byRecency: 'Most Recent',
    registered: 'Registered',
    walkIn: 'Walk-in Txns',
    walkInOrders: 'Walk-in Orders',
    repeatCustomers: 'Repeat Customers',
    customerRevenue: 'Customer Revenue',
    avgPerCustomer: 'Avg / Customer',
    walkInRevenue: 'Walk-in Revenue',
    top10Customers: 'Top 10 Customers by Revenue',
    revenueSplit: 'Revenue Split',
    customerTiers: 'Customer Tiers',
    tierGold: 'Gold',
    tierSilver: 'Silver',
    tierBronze: 'Bronze',
    firstVisit: 'First Visit',
    lastVisit: 'Last Visit',
    lastPurchase: 'Last Purchase',
    daysSinceLast: 'Days Since Last',
    visitDays: 'Visit Days',
    totalDiscount: 'Total Discount',
    totalDiscounts: 'Total Discounts',
    branches: 'Branches',
    favProducts: 'Favourite Products',
    allCustomers: 'All Customers',
    fullSessionSummary: 'Full session summary: sales, refunds & variance',
    sessionId: 'Session ID',
    opened: 'Opened',
    searchSession: 'Search # transaction, customer…',
    cashierSearch: 'Search # transaction, cashier...',
    peakHour: 'Peak Hour',
    peakHours: 'Peak Hours',
    peakSales: 'Peak Sales',
    bestDay: 'Best Day',
    dayOfWeek: 'Day of Week',
    totalDays: 'Total Days',
    totalHours: 'Total Hours',
    avgDailySales: 'Avg Daily Sales',
    avgOrderValue: 'Avg Order Value',
    avgOrder: 'Avg Order',
    avgPrice: 'Avg Price',
    avgProductRevenue: 'Avg Product Revenue',
    avgOrders: 'Avg Orders',
    avgCustomerValue: 'Avg Customer Value',
    uniqueCustomers: 'Unique Customers',
    newCustomers: 'New Customers',
    vipCustomers: 'VIP Customers',
    atRisk: 'At Risk',
    atRiskCustomers: 'At-Risk Customers',
    vipPlatinum: 'VIP / Platinum',
    segment: 'Segment',
    frequency: 'Frequency',
    frequencyPerDay: 'Frequency (orders/day)',
    lifetimeValue: 'Lifetime Value',
    firstOrder: 'First Order',
    lastOrder: 'Last Order',
    customerId: 'Customer ID',
    customerPhone: 'Customer Phone',
    totalSpent: 'Total Spent',
    searchCustomerPhone: 'Search customer, phone…',
    searchOrderProduct: 'Search # order, product…',
    productsSold: 'Products Sold',
    unitsSold: 'Units Sold',
    qtySold: 'Qty Sold',
    topMethod: 'Top Method',
    topPaymentMethod: 'Top Payment Method',
    failedLoadPaymentMethods: 'Failed to load payment methods',
    failedLoadCustomerOrders: 'Failed to load customer orders',
    failedLoadCustomersReport: 'Failed to load customers report',
    failedLoadOrdersReport: 'Failed to load orders report',
    failedLoadDailySales: 'Failed to load daily sales report',
    failedLoadHourly: 'Failed to load hourly analytics report',
    failedLoadProducts: 'Failed to load products report',
    customerReport: 'Customers — Behavior, Segments & Value',
    orderAnalytics: 'Transaction Analytics, Payments, Customers',
    revenueBar: 'Revenue (bar)',
    overview: 'Overview',
    totalPosSales: 'Total POS Sales',
    refunds: 'Refunds',
    preparing: 'Preparing',
    on_the_way: 'On the Way',
    collectedUsd: 'Collected (USD)',
    collectedKhr: 'Collected (KHR)',
  },

  // ── Customers ────────────────────────────────────────────────
  customers: {
    title: 'Customers',
    newCustomer: 'New Customer',
    name: 'Name',
    fullName: 'Full Name *',
    email: 'Email',
    phone: 'Phone',
    phoneNumber: 'Phone Number',
    address: 'Address',
    city: 'City',
    country: 'Country',
    type: 'Type',
    customerType: 'Customer Type',
    group: 'Group',
    customerGroup: 'Customer Group',
    creditLimit: 'Credit Limit',
    loyaltyPoints: 'Loyalty Points',
    discountPercent: 'Discount %',
    birthday: 'Birthday',
    isBlacklisted: 'Blacklisted',
    isActive: 'Active',
    business: 'Business',
    individual: 'Individual',
    regular: 'Regular',
    vip: 'VIP',
    wholesale: 'Wholesale',
    noCustomers: 'No customers found',
    searchPlaceholder: 'Search customers...',
    editCustomer: 'Edit Customer',
    deleteCustomer: 'Delete Customer',
    deleteConfirm: 'Delete this customer?',
    activate: 'Activate',
    deactivate: 'Deactivate',
    activated: 'Activated',
    deactivated: 'Deactivated',
    blacklist: 'Blacklist',
    unblock: 'Unblock',
    blacklisted: 'Blacklisted',
    removedFromBlacklist: 'Removed from blacklist',
    balance: 'Balance',
    points: 'Points',
    yourBranch: 'Your Branch',
    nameRequired: 'Name required',
    created: 'Customer created',
    updated: 'Customer updated',
    deleted: 'Customer deleted',
    discountGroupDesc: 'Discount % for this group',
    briefDescription: 'Brief description',
    totalCustomers: 'Total Customers',
    activeCustomers: 'Active Customers',
    activeBranches: 'Active Branches',
    columns: {
      customer: 'Customer',
      type: 'Type',
      phone: 'Phone',
      group: 'Group',
      branch: 'Branch',
      creditLimit: 'Credit Limit',
      balance: 'Balance',
      points: 'Points',
      status: 'Status',
      actions: 'Actions',
    },
  },

  // ── Products ─────────────────────────────────────────────────
  products: {
    title: 'Products',
    newProduct: 'New Product',
    addProduct: 'Add Product',
    editProduct: 'Edit Product',
    deleteProduct: 'Delete Product',
    sku: 'SKU',
    skuNameRequired: 'SKU and name required',
    nameEn: 'Name (EN)',
    nameKh: 'Name (KH)',
    category: 'Category',
    brand: 'Brand',
    brandName: 'Brand Name',
    brandLogo: 'Brand Logo',
    costPrice: 'Cost Price',
    salePrice: 'Sale Price',
    baseSalePrice: 'Base Sale Price',
    wholesalePrice: 'Wholesale Price',
    wholesale: 'Wholesale',
    minPrice: 'Min Price',
    stock: 'Stock',
    lowStock: 'Low Stock',
    outOfStock: 'Out of Stock',
    reorderLevel: 'Reorder Level',
    barcode: 'Barcode',
    isActive: 'Active',
    trackStock: 'Track Stock',
    allowNegativeStock: 'Allow Negative Stock',
    uom: 'Unit of Measure',
    selectUom: 'Select UoM',
    baseUnit: 'Base Unit',
    conversionFactor: 'Conversion Factor',
    factorDesc: 'Factor (number of base units)',
    pricePerThisUnit: 'Price / this unit',
    commission: 'Commission',
    commissionPercent: 'Commission %',
    pricePerUnit: 'Price / unit',
    taxPercent: 'Tax %',
    margin: 'Margin',
    description: 'Description',
    images: 'Images',
    imageUrl: 'Image URL (or upload above)',
    editUrl: 'Edit URL',
    newUrl: 'New URL...',
    setPrimary: 'Set as Primary',
    weightKg: 'Weight (kg)',
    safetyStock: 'Safety Stock',
    batchLotTracking: 'Batch/Lot Tracking',
    serialTracking: 'Serial Tracking',
    expiryTracking: 'Expiry Tracking',
    serialNumber: 'Serial Number',
    batchNumber: 'Batch Number',
    noProducts: 'No products found',
    searchPlaceholder: 'Search name, SKU, barcode...',
    deleteConfirm: 'Delete this product?',
    piece: 'Piece',
    urlRequired: 'URL required',
    uomPriceFailed: 'Failed to save UoM price',
    uploadedAdded: 'Uploaded and added',
    totalProducts: 'Total Products',
    columns: {
      img: 'Img',
      sku: 'SKU',
      product: 'Product',
      category: 'Category',
      brand: 'Brand',
      cost: 'Cost',
      sale: 'Sale',
      ws: 'WS',
      stock: 'Stock',
      uom: 'UoM',
      commission: 'Comm',
      track: 'Track',
      status: 'Status',
      barcode: 'Barcode',
      margin: 'Margin',
    },
  },

  // ── Inventory ────────────────────────────────────────────────
  inventory: {
    title: 'Inventory Management',
    subtitle: '{{n}} stock records',
    tabs: {
      stock:     'Stock Levels',
      reports:   'Stock Reports & UoM',
      movements: 'Movement History',
    },
    stockIn:  'Stock In',
    stockOut: 'Stock Out',
    allBranches:  'All Branches',
    allProducts:  'All Products',
    lowStockOnly: 'Low Stock Only',
    fromDate:     'From date',
    toDate:       'To date',
    col: {
      product:   'Product',
      branch:    'Branch',
      location:  'Location',
      onHand:    'On Hand',
      reserved:  'Reserved',
      available: 'Available',
      reorder:   'Reorder',
      unitCost:  'Unit Cost',
      value:     'Value',
      batch:     'Batch',
      expiry:    'Expiry',
      actions:   'Actions',
      sku:       'SKU',
      type:      'Type',
      qty:       'Qty',
      date:      'Date',
      reference: 'Reference',
      notes:     'Notes',
    },
    in:  'In',
    out: 'Out',
    stockInTitle:   'Stock In — Receive Goods',
    addingStock:    'Adding stock to inventory',
    receiveStock:   'Receive Stock',
    productRequired: 'Product *',
    branchRequired:  'Branch *',
    unitCostUsd:    'Unit Cost ($)',
    referenceType:  'Reference Type',
    batchNumber:    'Batch Number',
    serialNumber:   'Serial Number',
    expiryDate:     'Expiry Date',
    notesPlaceholder: 'Reason / PO reference...',
    totalValue:     'Total Value',
    refTypes: {
      purchase:    'Purchase Order',
      return:      'Customer Return',
      transfer:    'Transfer In',
      adjustment:  'Adjustment',
      manual:      'Manual Entry',
    },
    stockOutTitle:   'Stock Out — Issue Goods',
    removingStock:   'Removing stock from inventory',
    issueStock:      'Issue Stock',
    reasonLabel:     'Reason',
    reasonPlaceholder: 'Reason / SO reference...',
    issueTypes: {
      sale:          'Sale / Delivery',
      damage:        'Damaged / Expired',
      transfer:      'Transfer Out',
      return_vendor: 'Return to Vendor',
      manual:        'Manual Write-off',
    },
    selectUom:         'Unit of Measure',
    baseUnit:          'base',
    baseUnitLabel:     '(base unit)',
    uomPillFactor:     '×{{n}}',
    willAdd:           'will add',
    willRemove:        'will remove',
    toBaseStock:       'to base stock',
    fromBaseStock:     'from base stock',
    receiving:         'Receiving',
    issuing:           'Issuing',
    quantityIn:        'Quantity (in {{uom}})',
    quantityLabel:     'Quantity *',
    uomConversionNote: 'Receiving {{qty}} {{uom}} = will add {{base}} {{baseUnit}} to base stock',
    uomIssuanceNote:   'Issuing {{qty}} {{uom}} = will remove {{base}} {{baseUnit}} from base stock',
    reportTabs: {
      summary:    'Summary',
      byuom:      'By Unit Measure',
      valuation:  'Valuation',
      lowstock:   'Low / Out of Stock',
    },
    kpi: {
      totalSkus:    'Total SKUs',
      stockRecords: 'Stock Records',
      costValue:    'Cost Value',
      saleValue:    'Sale Value',
      lowStock:     'Low Stock',
      outOfStock:   'Out of Stock',
    },
    moveTypes: { all:'All', in:'in', out:'out', adjustment:'adjustment', transfer_in:'transfer_in', transfer_out:'transfer_out', return:'return', damage:'damage' },
    clearFilters: 'Clear',
    loadingInventory: 'Loading inventory...',
    productBranchQtyRequired: 'Product, branch, qty required',
    stockInSuccess:  'Stock IN: +{{qty}} base units',
    stockOutSuccess: 'Stock OUT: -{{qty}} base units',
    stockInFailed:   'Failed to receive stock',
    stockOutFailed:  'Failed to issue stock',
    stockRestored:       'Stock restored',
    stockRestoredVoid:   'Stock restored — transaction voided',
    stockRestoredCancel: 'Stock restored — invoice cancelled',
    stockRestoredDelete: 'Stock restored — invoice deleted',
    stockRestoredEdit:   'Stock restored — invoice items updated',
    voidRestoreNote:     'Void {{num}} — UoM ×{{factor}} (qty {{qty}}, restored {{base}} base units)',
    alreadyVoided:       'Transaction already voided',
    cantDeletePaid:      'Cannot delete invoice with payments recorded',
    cantEditStatus:      'Cannot edit invoice with status: {{status}}',
    uomConversion:       'UoM ×{{factor}} — sold {{qty}}, deducted {{base}} base units',
    baseUnitDeduction:   'Base unit deduction',
    boxExample:          'e.g. 1 Box = 24 Bottles',
    stockInTitle2:       'Stock In — Receive Goods',
    stockOutTitle2:      'Stock Out — Issue Goods',
    stockInSuccess2:     'Receive Stock',
    stockOutSuccess2:    'Issue Stock',
  },

  // ── Vendors ───────────────────────────────────────────────────
  vendors: {
    title: 'Vendors',
    newVendor: 'New Vendor',
    editVendor: 'Edit Vendor',
    deleteVendor: 'Delete Vendor',
    deleteConfirm: 'Delete permanently?',
    companyName: 'Company Name',
    contactPerson: 'Contact Person',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    city: 'City',
    country: 'Country',
    taxId: 'Tax ID',
    rating: 'Rating (0-5)',
    leadTime: 'Lead Time (days)',
    leadTimeDays: 'Lead Time',
    paymentTerms: 'Payment Terms',
    notes: 'Notes',
    isActive: 'Active',
    noVendors: 'No vendors found',
    searchPlaceholder: 'Search vendors...',
    nameRequired: 'Name required',
    days: 'days',
    noPermission: 'You do not have permission',
    columns: {
      vendor: 'Vendor',
      email: 'Email',
      phone: 'Phone',
      country: 'Country',
      rating: 'Rating',
      leadTime: 'Lead Time',
      terms: 'Terms',
      status: 'Status',
    },
  },

  // ── Commissions ───────────────────────────────────────────────
  commissions: {
    title: 'Commissions',
    subtitle: 'Manage, approve & analyse commission records',
    list: 'Commission List',
    rules: 'Rules',
    reports: 'Reports',
    commissionId: 'Commission ID',
    newRule: 'New Rule',
    newRuleBtn: '+ New Rule',
    createRule: 'Create Rule',
    editRule: 'Edit Rule',
    ruleCreated: 'Rule created',
    ruleUpdated: 'Rule updated',
    ruleDeleted: 'Rule deleted',
    commissionUpdated: 'Commission updated',
    noCommissions: 'No commissions found',
    noProductLinked: 'No commission data linked to product',
    searchPlaceholder: 'Search type, invoice, user, branch…',
    ratePercent: 'Rate (%) *',
    rateLabel: 'Rate (%)',
    baseAmount: 'Base Amount',
    base: 'Base',
    totalBase: 'Total Base Amount',
    totalCommission: 'Total Commission',
    totalRecords: 'Total Records',
    paidOut: 'Paid Out',
    paidAt: 'Paid At',
    byProduct: 'By Product',
    byType: 'By Type',
    byUser: 'By User',
    optionalNotes: 'Notes (optional)…',
    enterValidAmount: 'Please enter a valid amount',
    validRateRequired: 'Valid rate required',
    nameRequired: 'Name required',
    exported: 'Exported',
    failedLoad: 'Failed to load commissions',
    failedReport: 'Failed to load report',
    failedUpdate: 'Failed to update',
    noPermission: '🔒 You do not have permission to view commissions.',
    package: 'Package',
    priority: 'Priority',
    name: 'Name',
    ruleActive: 'Rule Active',
    appliesTo: 'Applies To',
    earned: 'Earned',
    commissionRecord: 'Commission Record',
    commissionRecords: 'Records',
    breakdownByStatus: 'Breakdown by Status',
    records: '{{n}} records',
    loadingReport: 'Loading report…',
    noData: 'No data',
    changeStatus: 'Change status to',
    selectAll: 'Select All',
    selected: '{{n}} selected',
    approveSelected: 'Approve Selected',
    markPaid: 'Mark Paid',
    cancelSelected: 'Cancel',
    bulkApproved: '{{n}} commission(s) → approved',
    bulkPaid: '{{n}} commission(s) → paid',
    bulkCancelled: '{{n}} commission(s) cancelled',
    bulkFailed: 'Bulk action failed',
    clearSelection: 'Clear',
    addOptionalNote: 'Add an optional note.',
    current: 'Current',
    statusChanged: 'Status → {{status}}',
    editCommission: 'Edit Commission #{{id}}',
    amountUsd: 'Amount ($) *',
    type: 'Type',
    user: 'User',
    invoice: 'Invoice',
    saveChanges: 'Save Changes',
    allStatuses: 'All Statuses',
    allTypes: 'All Types',
    allBranches: 'All Branches',
    allUsers: 'All Users',
    statusFilter: 'Status',
    typeFilter: 'Type',
    branchFilter: 'Branch',
    userFilter: 'User',
    fromDate: 'From',
    toDate: 'To',
    apply: 'Apply',
    loading: 'Loading…',
    runReport: 'Run Report',
    ruleName: 'Name *',
    ruleNamePlaceholder: 'e.g. Sales Rep 5%',
    ruleType: 'Type *',
    ruleAppliesTo: 'Applies To',
    priorityLabel: 'Priority',
    activeLabel: 'Active',
    rulesCount: '{{n}} rules',
    types: {
      ownerBusiness: 'Business Owner',
      ownerBranch: 'Branch Owner',
      salesRep: 'Sales Representative',
      customerDiscount: 'Customer Discount',
      custom: 'Custom',
    },
    appliesToOptions: {
      all: 'All',
      category: 'Category',
      product: 'Product',
      branch: 'Branch',
    },
    columns: {
      id: '#',
      type: 'Type',
      user: 'User',
      branch: 'Branch',
      invoice: 'Invoice',
      baseAmount: 'Base Amount',
      rate: 'Rate',
      amount: 'Amount',
      status: 'Status',
      actions: 'Actions',
      paidAt: 'Paid At',
      product: 'Product',
      sku: 'SKU',
      count: 'Count',
      name: 'Name',
      created: 'Created',
      notes: 'Notes',
    },
    status: {
      pending: 'Pending',
      approved: 'Approved',
      paid: 'Paid',
      cancelled: 'Cancelled',
    },
  },

  // ── Payments ──────────────────────────────────────────────────
  payments: {
    title: 'Payments',
    subtitle: 'Amounts, methods, invoice balances & outstanding',
    records: 'Records',
    list: 'Payment List',
    analytics: 'Analytics',
    paymentNumber: 'Payment #',
    paymentTransaction: 'Payment Transaction',
    refundTransaction: 'Refund Transaction',
    noPayments: 'No payments found',
    allMethods: 'All Methods',
    allStatus: 'All Status',
    allTypes: 'All Types',
    allBranches: 'All Branches',
    yourBranch: 'Your Branch',
    showingBranchOnly: '— Showing your branch payments',
    byBranch: 'By Branch',
    byMethod: 'Method',
    unassigned: 'Unassigned',
    unknown: 'Unknown',
    other: 'Other',
    done: 'Done',
    refund: 'Refund',
    failedLoad: 'Failed to load payments',
    collected: 'Collected',
    pending: 'Pending',
    refunded: 'Refunded',
    failed: 'Failed',
    netCollected: 'Net Collected',
    khrCollected: 'Collected (KHR)',
    branches: 'Branches',
    methods: 'Methods',
    withActivity: 'With Activity',
    paymentMethods: 'Payment Methods',
    fromDate: 'From Date',
    toDate: 'To Date',
    transactions: 'Transactions',
    searchPlaceholder: 'Search # payment, customer, reference...',
    viewDetail: 'View Detail',
    columns: {
      paymentNum: 'Payment #',
      invoice: 'Invoice',
      customer: 'Customer',
      branch: 'Branch',
      amount: 'Amount',
      method: 'Method',
      currency: 'Currency',
      type: 'Type',
      status: 'Status',
      date: 'Date',
      reference: 'Reference',
      notes: 'Notes',
      actions: 'Actions',
    },
    status: {
      completed: 'Completed',
      pending: 'Pending',
      failed: 'Failed',
      refunded: 'Refunded',
    },
    type: {
      payment: 'Payment',
      refund: 'Refund',
    },
  },

  // ── Promotions ────────────────────────────────────────────────
  promotions: {
    title: 'Promotions',
    newPromotion: 'New Promotion',
    editPromotion: 'Edit Promotion',
    noPromotions: 'No promotions found',
    name: 'Name',
    description: 'Description',
    type: 'Type',
    value: 'Value',
    appliesTo: 'Applies To',
    startDate: 'Start Date',
    start: 'Start',
    endDate: 'End Date',
    end: 'End',
    minPurchase: 'Min Purchase',
    buyQty: 'Buy Qty',
    getQty: 'Get Qty',
    isActive: 'Active',
    nameRequired: 'Name required',
    enabled: 'Enabled',
    disabled: 'Disabled',
    types: {
      percentage: 'Percentage',
      fixed: 'Fixed Amount',
      buyXGetY: 'Buy X Get Y',
    },
    appliesOptions: {
      all: 'All',
      category: 'Category',
      product: 'Product',
      customerGroup: 'Customer Group',
    },
    columns: {
      name: 'Name',
      type: 'Type',
      value: 'Value',
      appliesTo: 'Applies To',
      start: 'Start',
      end: 'End',
      status: 'Status',
    },
  },

  // ── Currencies & Exchange Rates ───────────────────────────────
  currencies: {
    title: 'Currencies & Exchange Rates',
    subtitle: '{{c}} currencies · {{r}} global rates · {{b}} branch rates',
    tabCurrencies: 'Currencies',
    tabRates: 'Global Rates',
    tabBranchRates: 'Branch Rates',
    code: 'Code',
    name: 'Name',
    symbol: 'Symbol',
    isDefault: 'Default',
    isActive: 'Active',
    fromCurrency: 'From',
    toCurrency: 'To',
    rate: 'Rate',
    effectiveDate: 'Effective Date',
    defaultLabel: 'Default',
    noCurrencies: 'No currencies found',
    noRates: 'No rates found',
    noBranchRates: 'No branch rates found',
    newCurrency: 'New Currency',
    editCurrency: 'Edit Currency',
    newRate: 'New Rate',
    editRate: 'Edit Rate',
    newBranchRate: 'New Branch Rate',
    editBranchRate: 'Edit Branch Rate',
    addCurrency: 'Add Currency',
    addRate: 'Add Global Rate',
    addBranchRate: 'Add Branch Rate',
    globalRatesDesc: 'System-wide exchange rates used as default across all branches',
    branchRatesDesc: 'Per-branch rates override the global rate for specific branches',
    branchRateOverride: 'Branch Override',
    usesGlobalRate: 'Uses Global Rate',
    latestRate: 'Latest Rate',
    previousRate: 'Previous Rate',
    rateChange: 'Change',
    notes: 'Notes',
    notesPlaceholder: 'Optional notes...',
    branch: 'Branch',
    allBranches: 'All Branches',
    setDefault: 'Set Default',
    activateLabel: 'Active',
    currencyUpdated: 'Currency updated',
    rateCreated: 'Rate created',
    rateUpdated: 'Rate updated',
    rateDeleted: 'Rate deleted',
    branchRateCreated: 'Branch rate created',
    branchRateUpdated: 'Branch rate updated',
    branchRateDeleted: 'Branch rate deleted',
    confirmDelete: 'Delete this rate?',
    createdBy: 'Created By',
    noPermission: 'You do not have permission to manage currencies.',
    filterBranch: 'Filter by Branch',
    filterCurrency: 'Filter by Currency',
    rateHistory: 'Rate History',
    currentRate: 'Current Rate',
    columns: {
      code: 'Code',
      name: 'Name',
      symbol: 'Symbol',
      default: 'Default',
      status: 'Status',
      from: 'From',
      to: 'To',
      rate: 'Rate',
      date: 'Effective Date',
      notes: 'Notes',
      branch: 'Branch',
      createdBy: 'Created By',
      actions: 'Actions',
    },
  },

  // ── Master Data ───────────────────────────────────────────────
  masterData: {
    title: 'Master Data',
    subtitle: 'Manage categories, units, brands & customer groups',
    categories: 'Categories',
    uom: 'Units of Measure',
    unitsOfMeasure: 'Units of Measure',
    brands: 'Brands',
    customerGroups: 'Customer Groups',
    addCategory: 'Add Category',
    newCategory: 'New Category',
    editCategory: 'Edit Category',
    deleteCategory: 'Delete Category',
    categoryName: 'Category Name',
    categoryImage: 'Category Image',
    newUom: 'New UoM',
    editUom: 'Edit UoM',
    deleteUom: 'Delete UoM',
    unitName: 'Unit Name',
    newBrand: 'New Brand',
    editBrand: 'Edit Brand',
    deleteBrand: 'Delete Brand',
    newCustomerGroup: 'New Customer Group',
    editCustomerGroup: 'Edit Customer Group',
    deleteGroup: 'Delete Group',
    groupName: 'Group Name',
    parentCategory: 'Parent Category',
    noneTopLevel: '— None (top-level) —',
    sortOrder: 'Sort Order',
    abbreviation: 'Abbreviation',
    abbr: 'Abbr',
    factor: 'Factor',
    conversionFactor: 'Conversion Factor',
    baseUom: 'Base UoM',
    website: 'Website',
    discountPercent: 'Discount %',
    discountGroupDesc: 'Discount % for this group',
    creditLimit: 'Credit Limit',
    nameRequired: 'Name required',
    nameAbbrRequired: 'Name and abbreviation required',
    nameCodeRequired: 'Name and code required',
    searchCategories: 'Search categories...',
    searchUom: 'Search units...',
    searchBrands: 'Search brands...',
    searchGroups: 'Search groups...',
    image: 'Image',
    maxFileSize: 'Max 5MB',
    uploadFailed: 'Upload failed',
    uploaded: 'Uploaded',
    isActive: 'Active',
    topLevel: 'Top Level',
    optionalDescription: 'Description (optional)...',
    briefDescription: 'Brief description',
    columns: {
      name: 'Name',
      abbreviation: 'Abbreviation',
      factor: 'Factor',
      status: 'Status',
      website: 'Website',
      discount: 'Discount',
      credit: 'Credit',
    },
  },

  // ── Reports ──────────────────────────────────────────────────
  reports: {
    title: 'Reports',
    subtitle: 'Comprehensive business analytics across all modules',
    salesReport: 'Sales Report',
    orderReport: 'Order Report',
    customerReport: 'Customer Report',
    dateRange: 'Date Range',
    groupBy: 'Group By',
    runReport: 'Run Report',
    exportCsv: 'Export CSV',
    noPermission: "You don't have permission to view reports.",
    groups: { pos: 'POS', sales: 'Sales', customers: 'Customers', inventory: 'Inventory', finance: 'Finance' },
    tabs: {
      posSummary:'POS Summary', posSessions:'POS Sessions', cashRegister:'Cash Register',
      salesOrders:'Orders', salesInvoices:'Invoices', customers:'Customers',
      productSales:'Product Sales', stock:'Stock Levels', vendors:'Vendors',
      payments:'Payments', commissions:'Commissions',
    },
    today:'Today', thisMonth:'This Month', last30:'Last 30d', thisYear:'This Year',
    allBranches:'All Branches', allStatus:'All Status', allCategories:'All Categories',
    refresh:'Refresh', loading:'Loading…', noData:'No data',
    transactions:'Transactions', totalSales:'Total Sales', totalDiscount:'Total Discount',
    avgOrder:'Avg Order', totalSessions:'Total Sessions', totalVariance:'Total Variance',
    cashIn:'Cash In', cashOut:'Cash Out', net:'Net',
    totalOrders:'Total Orders', revenue:'Revenue', discount:'Discount',
    totalInvoices:'Total Invoices', totalRevenue:'Total Revenue', totalPaid:'Total Paid',
    outstanding:'Outstanding', taxCollected:'Tax Collected',
    uniqueCustomers:'Unique Customers', customerRevenue:'Customer Revenue',
    avgPerCustomer:'Avg per Customer', walkInRevenue:'Walk-in Revenue',
    productsSold:'Products Sold', totalProfit:'Total Profit',
    skusTracked:'SKUs Tracked', stockValue:'Stock Value', lowStock:'Low Stock', outOfStock:'Out of Stock',
    totalVendors:'Total Vendors', payments:'Payments', usdCollected:'USD Collected', khrCollected:'KHR Collected',
    records:'Records', totalAmount:'Total Amount', pending:'Pending', approved:'Approved', paidOut:'Paid Out',
    paymentMethodBreakdown:'Payment Method Breakdown', byBranch:'By Branch',
    sessionDetails:'Session Details', cashEntries:'Cash Register Entries',
    topProducts:'Top Products', topCustomers:'Top Customers',
    orderList:'Order List', invoiceList:'Invoice List',
    invoiceStatusBreakdown:'Invoice Status Breakdown',
    top10Customers:'Top 10 Customers by Revenue', customerBreakdown:'Customer Breakdown',
    top10ByRevenue:'Top 10 by Revenue', profitMargins:'Profit Margins',
    productSalesDetail:'Product Sales Detail', stockLevels:'Stock Levels',
    vendorSummary:'Vendor Summary', dailyCashFlow:'Daily Cash Flow',
    paymentDetails:'Payment Details', commissionByPerson:'Commission by Salesperson',
    col:{
      method:'Method', txns:'Txns', amount:'Amount', branch:'Branch',
      session:'Session', cashier:'Cashier', status:'Status',
      opened:'Opened', closed:'Closed', opening:'Opening', closing:'Closing',
      expected:'Expected', variance:'Variance', sales:'Sales',
      type:'Type', user:'User', notes:'Notes', date:'Date',
      orderNum:'Order #', customer:'Customer', subtotal:'Subtotal',
      tax:'Tax', total:'Total', items:'Items', invoiceNum:'Invoice #',
      dueDate:'Due Date', paid:'Paid', balance:'Balance',
      phone:'Phone', pos:'POS', invoices:'Invoices', last:'Last',
      product:'Product', sku:'SKU', category:'Category',
      qtySold:'Qty Sold', profit:'Profit', margin:'Margin',
      reorder:'Reorder', safety:'Safety', value:'Value',
      vendor:'Vendor', products:'Products', stock:'Total Stock',
      payNum:'Payment #', invoice:'Invoice', orig:'Orig',
      salesperson:'Salesperson', commission:'Commission',
    },
    filter:{ lowStock:'Low Stock', outOfStock:'Out of Stock', all:'All' },
  },

  // ── Settings ─────────────────────────────────────────────────
  settings: {
    title: 'System Settings',
    subtitle: 'Configuration & Telegram Notifications',
    general: 'General',
    generalSettings: 'General Settings',
    companyName: 'Company Name',
    notifications: 'Notifications',
    notificationLog: 'Notification Log',
    telegram: 'Telegram',
    telegramAlerts: 'Telegram Alerts',
    telegramChatId: 'Telegram Chat ID',
    botToken: 'Bot Token',
    testConnection: 'Test Connection',
    sendTest: 'Send Test',
    configure: 'Configure',
    connected: 'Connected',
    noConfig: 'No Chat ID configured',
    noConfigDesc: 'No Chat ID configured — click Configure to set up',
    notConfigured: 'Not configured',
    events: 'Notification Events',
    eventsCount: '{{n}} types',
    daily: 'Daily Report',
    dailySalesReport: 'Daily Sales Report',
    lowStockAlert: 'Low Stock Alert',
    lowStock: 'Low Stock Alert',
    largeDiscountAlert: 'Large Discount Alert',
    newOrdersNotif: 'New Orders & Status',
    sendNow: 'Send Now',
    chatId: 'Chat ID',
    customMessage: 'Custom Message (optional)',
    leaveBlankDefault: 'Leave blank to use default test message',
    save: 'Save Changes',
    saved: 'Saved',
    settingsSaved: 'Settings saved',
    dailySent: 'Daily report sent!',
    lowStockSent: 'Low stock alert sent!',
    testSent: 'Test message sent!',
    sendFailed: 'Send failed',
    urlApplied: 'URL applied',
    chooseFile: 'Choose File',
    logoUrl: 'Logo URL',
    logoUploaded: 'Logo uploaded',
    discountThreshold: 'Discount Threshold (%)',
    discountAlertDesc: 'Live alert when discount exceeds %',
    endOfDayDesc: 'End-of-day summary: POS invoices, collections, outstanding',
    english: 'English',
    khmer: 'Khmer',
    automatic: 'Automatic',
    scheduled: 'Scheduled',
    unread: 'Unread',
    markRead: 'Mark as read',
    // Bot status
    botConnected: 'Bot Connected',
    botInvalid: 'Bot Token Invalid',
    botNotConfigured: 'Bot Not Configured',
    botCheckStatus: 'Checking bot status...',
    botTokenDesc: 'Set TELEGRAM_BOT_TOKEN in your server .env to enable notifications',
    botInvalidDesc: 'TELEGRAM_BOT_TOKEN is set but returned an error — check your token',
    botApiReady: 'Telegram Bot API ready',
    refresh: 'Refresh',
    // Branch telegram config
    branchTelegramConfig: 'Branch Telegram Configuration',
    branchTelegramDesc: 'Each branch needs its own Telegram Chat ID',
    branchTelegramHint: 'Get your Chat ID by messaging @userinfobot in Telegram',
    configured: 'Configured',
    noBranches: 'No branches found',
    yourBranchOnly: 'You can only manage your own branch Chat ID',
    // Notification events
    cashRegisterClosed: 'Cash Register Closed',
    cashRegisterClosedDesc: 'Full session summary with sales, refunds & cash variance',
    invoiceCreated: 'Invoice Created',
    invoiceCreatedDesc: 'Customer name, total, due date and created-by',
    saleOrder: 'Sale Order',
    saleOrderDesc: 'New orders and status changes (confirmed, shipped, etc.)',
    paymentReceived: 'Payment Received',
    paymentReceivedDesc: 'Amount, method, invoice balance and outstanding',
    dailyReport: 'Daily Sales Report',
    dailyReportDesc: 'End-of-day summary: invoices, POS, collections, outstanding',
    lowStockDesc: 'Products below reorder level grouped by branch',
    largeDiscount: 'Large Discount Alert',
    largeDiscountDesc: 'Real-time alert when discount exceeds threshold %',
    // Test message
    sendTestMessage: 'Send Test Message',
    sendTestDesc: "Verify a branch's Telegram connection is working",
    selectBranch: '— Select Branch —',
    sendTestBtn: 'Send Test',
    sending: 'Sending...',
    // Manual triggers
    manualTriggers: 'Manual Triggers',
    manualTriggersDesc: 'Force-send scheduled reports now to all configured branches',
    autoSchedule: 'Auto-schedule',
    discountThresholdLabel: 'Discount threshold',
    // Notification log
    all: 'All',
    total: 'Total',
    unreadLabel: 'Unread',
    telegramChannel: 'Telegram',
    systemChannel: 'System',
    read: 'Read',
    deleteNotif: 'Delete notification',
    // Edit / configure
    editChatId: 'Edit',
    setChatId: 'Configure',
    testSend: 'Test',
    removeChatId: 'Remove',
    saveChatId: 'Save',
    cancelEdit: 'Cancel',
  },

  // ── Users ────────────────────────────────────────────────────
  users: {
    title: 'Users, Roles & Access Control',
    titleFull: 'Users, Roles & Access Control',
    subtitle: '{{users}} users · {{roles}} roles',
    newUser: 'Add User',
    addUser: 'Add User',
    assignRole: 'Assign Role',
    roleAssigned: 'Role updated',
    roleAssignFailed: 'Failed to update role',
    noRole: '— No Role —',
    usersWithRole: '{{n}} user',
    usersWithRolePlural: '{{n}} users',
    tabs: {
      users: 'Users',
      roles: 'Roles & Permissions',
      matrix: 'Access Matrix',
      audit: 'Audit Logs',
      logins: 'Login History',
    },
    quickTemplate: 'QUICK LOAD FROM TEMPLATE',
    permCount: '{{n}} of {{total}} selected',
    newRole: 'New Role',
    createUser: 'Create User',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    firstName: 'First Name',
    firstNameReq: 'First Name *',
    lastName: 'Last Name',
    email: 'Email',
    emailReq: 'Email *',
    role: 'Role',
    roleReq: 'Role *',
    selectRole: '— Select Role —',
    branch: 'Branch',
    noBranch: '— No Branch —',
    lockedBranch: '(locked to your branch)',
    phone: 'Phone',
    commissionRate: 'Commission Rate (%)',
    language: 'Language',
    password: 'Password',
    passwordReq: 'Password *',
    newPassword: 'New Password (leave blank = no change)',
    passwordRequired: 'Password required',
    nameEmailRequired: 'Name & email required',
    isActive: 'Active',
    allRoles: 'All Roles',
    allBranches: 'All Branches',
    noUsers: 'No users found',
    searchPlaceholder: 'Search by name or email…',
    activate: 'Activate',
    deactivate: 'Deactivate',
    activated: 'Activated',
    deactivated: 'Deactivated',
    created: 'User created',
    updated: 'User updated',
    deleted: 'User deleted',
    assigned: 'User assigned',
    removed: 'Removed',
    failedLoad: 'Failed to load users',
    failedSave: 'Failed to save user',
    failedDelete: 'Failed to delete user',
    failedUpdateStatus: 'Failed to update status',
    outsideBranch: 'Outside your branch — view only',
    branchScopedView: 'Branch-scoped view:',
    branchScopedNote: '— You can only manage users in your assigned branch',
    canOnlyManage: 'You can only manage users in your assigned branch',
    restricted: 'Restricted',
    tabUsers: 'Users',
    tabRoles: 'Roles & Permissions',
    tabMatrix: 'Access Matrix',
    tabAudit: 'Audit Logs',
    tabLogins: 'Login History',
    tableView: 'Table',
    cardsView: 'Cards',
    viewTable: 'Table',
    viewCards: 'Cards',
    yourBranchUsers: 'Your Branch Users',
    otherBranchUsers: 'Other Branch Users — Restricted',
    rolesAndPermissions: 'Roles & Permissions',
    accessMatrix: 'Access Matrix',
    matrixDesc: '— Shows modules accessible by each role',
    ownerOnly: 'OWNER ONLY',
    hasAccess: 'Has Access',
    noAccess: 'No Access',
    topRowNote: 'Top row = view · Bottom row = create/manage',
    module: 'Module',
    permissions: 'Permissions',
    permissionCount: '{{count}} permissions',
    permissionsLabel: 'PERMISSIONS',
    roleDetailTitle: 'Role Detail & Management',
    createRole: 'Create Role',
    editRole: 'Edit Role',
    deleteRole: 'Delete Role',
    roleCreated: 'Role created',
    roleUpdated: 'Role updated',
    roleDeleted: 'Role deleted',
    roleName: 'Role Name *',
    roleDescription: 'Description',
    roleNamePlaceholder: 'e.g. Warehouse Manager',
    roleDescPlaceholder: 'Brief description',
    loadTemplate: 'Load Template',
    selectTemplate: 'Select template...',
    systemRole: 'System',
    customRole: 'Custom',
    nameRequired: 'Name required',
    branchScope: 'Scope',
    fullGlobalAccess: 'Full global access',
    globalAllBranches: 'HQ (all branches)',
    allBranchesOwner: 'All branches (owner)',
    branchScoped: 'Branch-scoped',
    branchScopedInherits: 'Branch-scoped (inherits role)',
    restrictedBranch: 'Restricted to assigned branch',
    ownerGlobalAccess: 'Owner / global access',
    globalAccess: 'Global (all branches)',
    scope: 'Scope',
    full: 'Full',
    partial: 'Partial',
    selectBranch: 'Select Branch',
    auditLogs: 'Audit Logs',
    usersRoles: 'Users / Roles',
    commLabel: 'Comm',
    lastLogin: 'Last Login',
    loginHistory: 'Login History',
    never: 'Never',
    managerName: 'Manager Name',
    active: 'Active',
    inactive: 'Inactive',
    noLogs: 'No logs found',
    deleteUserTitle: 'Delete {{name}}?',
    deleteUserWarning: 'This action cannot be undone.',
    roleDeleteWarning: 'Users with this role will lose their permissions. This cannot be undone.',
    ownerOnlyWarning: 'Permissions marked OWNER ONLY are enforced at the server level and grant cross-branch access.',
    selectAll: 'All',
    selectNone: 'None',
    permGroups: {
      dashboard: 'Dashboard',
      branches: 'Branches',
      users: 'Users',
      customers: 'Customers',
      vendors: 'Vendors',
      products: 'Products',
      inventory: 'Inventory / Stock',
      saleOrders: 'Sale Orders',
      saleInvoices: 'Sale Invoices',
      posTerminal: 'POS Terminal',
      posSessions: 'POS Sessions',
      commissions: 'Commissions',
      promotions: 'Promotions',
      payments: 'Payments',
      reports: 'Reports',
      settings: 'Settings',
      system: 'System',
    },
    permLabels: {
      view: 'View',
      create: 'Create',
      edit: 'Edit',
      delete: 'Delete',
      manage: 'Manage',
      approve: 'Approve',
      cancel: 'Cancel',
      export: 'Export',
      transfer: 'Transfer',
      refund: 'Refund',
      discount: 'Discount',
      payment: 'Payment',
      analytics: 'Analytics',
      adjust: 'Adjust',
      access: 'Access',
      report: 'Report',
      financial: 'Financial',
      sales: 'Sales',
      commission: 'Commission',
      inventory: 'Inventory',
      cash_io: 'Cash In/Out',
      loyalty: 'Loyalty',
      open_session: 'Open Session',
      close_session: 'Close Session',
      sessions_view: 'View Sessions',
      sessions_report: 'Sessions Report',
      close_register: 'Close Register',
    },
    modules: {
      dashboard: 'Dashboard',
      posTerminal: 'POS Terminal',
      openPosSession: 'Open POS Session',
      closePosSession: 'Close POS Session',
      posSessionsView: 'View POS Sessions',
      saleOrders: 'Sale Orders',
      saleInvoices: 'Sale Invoices',
      customers: 'Customers',
      vendors: 'Vendors',
      products: 'Products',
      inventory: 'Inventory',
      commissions: 'Commissions',
      payments: 'Payments',
      reports: 'Reports',
      usersRoles: 'Users / Roles',
      settings: 'Settings',
      auditLogs: 'Audit Logs',
    },
    subLabels: {
      analytics: 'Analytics',
      discounts: 'Discounts',
      registerOpen: 'Register Open',
      forceClose: 'Force Close',
      matrixReports: 'Reports',
      create: 'Create',
      createEdit: 'Create / Edit',
      manage: 'Manage',
      adjust: 'Adjust',
      financial: 'Financial',
      edit: 'Edit',
    },
    columns: {
      user: 'User',
      role: 'Role',
      branchScope: 'Branch / Scope',
      phone: 'Phone',
      commission: 'Comm',
      lastLogin: 'Last Login',
      status: 'Status',
      actions: 'Actions',
    },
    roles: {
      owner: 'Owner',
      admin: 'Admin',
      branchManager: 'Branch Manager',
      supervisor: 'Supervisor',
      cashier: 'Cashier',
      salesRep: 'Sales Rep',
      salesRepresentative: 'Sales Representative',
      accountant: 'Accountant',
      salesViewer: 'Sales Viewer',
      stockViewer: 'Stock Viewer',
      inventoryStaff: 'Inventory Staff',
      posManager: 'POS Manager',
      financial: 'Financial',
      custom: 'Custom',
    },
    audit: {
      entity: 'Entity',
      action: 'Action',
      oldValues: 'Old Values',
      newValues: 'New Values',
      id: 'ID',
      ip: 'IP',
      ipAddress: 'IP Address',
      device: 'Device',
      time: 'Time',
      allEntities: 'All Entities',
      allActions: 'All Actions',
      auditLogDetail: 'Audit Log Detail',
      actions: {
        create: 'Create',
        update: 'Update',
        delete: 'Delete',
        statusChange: 'Status Change',
        payment: 'Payment',
        posClose: 'POS Close',
      },
      entities: {
        saleOrder: 'Sale Order',
        saleInvoice: 'Sale Invoice',
        posSession: 'POS Session',
        commission: 'Commission',
        product: 'Product',
        user: 'User',
      },
    },
  },

  // ── Branches ─────────────────────────────────────────────────
  branches: {
    title: 'Branches',
    subtitle: '{{total}} branches · {{telegram}} Telegram · {{logo}} with logo',
    subtitleOwner: 'All branches — Owner view',
    subtitleBranch: 'Your branch',
    newBranch: 'New Branch',
    createBranch: 'Create Branch',
    editBranch: 'Edit Branch',
    deleteBranch: 'Delete Branch',
    code: 'Code',
    branchCode: 'Branch Code *',
    branchName: 'Branch Name *',
    address: 'Address',
    fullAddress: 'Full address...',
    phone: 'Phone',
    email: 'Email',
    city: 'City',
    isHeadquarters: 'Headquarters?',
    isActive: 'Active',
    yesHq: 'Yes — Headquarters',
    noRegular: 'No — Regular Branch',
    noBranches: 'No branches found',
    noBranchAssigned: 'No branch assigned to your account',
    searchPlaceholder: 'Search by name, code, city...',
    created: 'Branch created',
    updated: 'Branch updated',
    failedLoad: 'Failed to load branches',
    failedUpdateStatus: 'Failed to update status',
    nameCodeRequired: 'Name and code required',
    managerName: 'Manager Name',
    taxRate: 'Tax Rate (%)',
    openingTime: 'Opening Time',
    closingTime: 'Closing Time',
    logoUpload: 'Branch Logo',
    uploadOrUrl: 'Upload or URL',
    telegramNotifications: 'Telegram Notifications',
    telegramChatId: 'Telegram Chat ID',
    telegramConfigured: 'Configured',
    telegramNotConfigured: 'Not configured',
    telegramSet: 'Set',
    telegramEdit: 'Edit',
    telegramTest: 'Test',
    telegramRemove: 'Remove',
    telegramHint: 'Get your Chat ID by messaging @userinfobot in Telegram.',
    assignedUsers: 'ASSIGNED USERS ({{n}})',
    assignUser: 'Assign User',
    noUsersAssigned: 'No users assigned to this branch',
    selectUser: '— Select user —',
    userWillMove: 'Currently in {{branch}} — will be moved here.',
    removeFromBranch: 'Remove from branch',
    yourBranchOnly: 'You can only view your assigned branch',
    viewingBranch: 'Viewing: {{name}}',
    deleteWarning: 'Are you sure you want to delete this branch? This cannot be undone.',
    eMmenu: 'e-Menu',
    preview: 'PREVIEW',
    uploadLogoTitle: 'Branch Logo',
    useUrl: 'Use URL',
    uploadFile: 'Upload',
    dropOrClick: 'Drop or click',
    imageFormats: 'PNG · JPG · WEBP · SVG · Max 5MB',
    changeFile: 'Change',
    chooseFile: 'Choose File',
    logoUploaded: 'Logo uploaded',
    uploadFailed: 'Upload failed',
    urlApplied: 'URL applied',
    cannotLoadImage: 'Cannot load image from this URL',
    columns: {
      code: 'Code',
      name: 'Name',
      address: 'Address',
      phone: 'Phone',
      hq: 'HQ',
      status: 'Status',
      actions: 'Actions',
    },
  },

  // ── Audit Logs ────────────────────────────────────────────────
  audit: {
    title: 'Activity Audit Logs',
    auditLogDetail: 'Audit Log Detail',
    entity: 'Entity',
    action: 'Action',
    user: 'User',
    branch: 'Branch',
    date: 'Date',
    time: 'Time',
    device: 'Device',
    channel: 'Channel',
    ipAddress: 'IP Address',
    description: 'Description',
    noLogs: 'No logs found',
    statusChange: 'Status Change',
    saleOrder: 'Sale Order',
    saleInvoice: 'Sale Invoice',
    posSession: 'POS Session',
    oldValues: 'Old Values',
    newValues: 'New Values',
  },

  // ── Status labels (shared) ────────────────────────────────────
  status: {
    active: 'Active',
    inactive: 'Inactive',
    open: 'Open',
    closed: 'Closed',
    pending: 'Pending',
    completed: 'Completed',
    cancelled: 'Cancelled',
    draft: 'Draft',
    paid: 'Paid',
    voided: 'Voided',
    refunded: 'Refunded',
    approved: 'Approved',
    failed: 'Failed',
    sent: 'Sent',
    partial: 'Partial',
    overdue: 'Overdue',
    processing: 'Processing',
    shipped: 'Shipped',
    confirmed: 'Confirmed',
  },

  // ── UoM / Stock ───────────────────────────────────────────────
  uom: {
    selectUnit:       'Unit of Measure',
    baseUnit:         'Base Unit',
    alternativeUnits: 'Alternative Units',
    conversionFactor: 'Conversion Factor',
    example:          'e.g. 1 Box = 24 Bottles',
    soldAs:           'Sold as',
    stockDeductedAs:  'Stock deducted as',
    baseUnits:        'base units',
    factor:           '×{{n}} conversion',
    stockNote:        '{{sold}} {{uom}} = {{base}} base units deducted',
    insufficientStock:'Need {{need}} base units ({{qty}} × ×{{factor}}), available: {{available}}',
    uomDeduction:     'UoM ×{{factor}} (sold {{qty}}, deducted {{base}} base units)',
  },

};

export default en;
